import { Component, computed, ElementRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DraggableDialogHeaderComponent } from '@ui-lib/services';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { FileDirective } from '../../../../../../../../directives/file.directive';
import $ from 'jquery';

@Component({
  selector: 'gallery-dialog',
  imports: [FileDirective, DraggableDialogHeaderComponent],
  templateUrl: './gallery-dialog.component.html',
  styleUrl: './gallery-dialog.component.scss',
})
export class GalleryDialogComponent implements OnInit {
  // Injections
  private readonly env = inject<PIMSEnvironment>(ENVIRONMENT);
  dialogRef = inject(MatDialogRef<GalleryDialogComponent>);
  data = inject(MAT_DIALOG_DATA);

  // Signals
  rotations = signal<Array<number>>([]);
  readonly imageContainer = viewChild<ElementRef<HTMLDivElement>>('imageContainer');

  // Computed
  readonly imageContainerHeight = computed(() => this.imageContainer()?.nativeElement.offsetHeight ?? 0);
  readonly imageContainerWidth = computed(() => this.imageContainer()?.nativeElement.offsetWidth ?? 0);

  ngOnInit(): void {
    this.rotations.set(Array(this.data.files.length).fill(0));
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.data.files));
  }

  get currentFile() {
    return this.data.files[this.data.index];
  }

  requiresAction() {
    return this.data.requiresAction();
  }

  setStatus(status: boolean) {
    this.data.files[this.data.index] = {
      ...this.currentFile,
      rejected: status,
    };
  }

  next() {
    this.data.index = (this.data.index + 1) % this.data.files.length;
  }

  previous() {
    this.data.index = (this.data.index - 1 + this.data.files.length) % this.data.files.length;
  }

  rotate() {
    this.rotations.update(rotations =>
      rotations.map((rotation, index) =>
        index === this.data.index ? rotation + 90 : rotation,
      ),
    );
  }
}
